import { Input } from "components/ui/input";
import { Label } from "components/ui/label";

import { timezonePlace } from "../events/timezones";

/**
 * A date and a time on an event's clock, as one "YYYY-MM-DDTHH:mm" value.
 *
 * Shared by the agenda's session times and an announcement's send time, so
 * both read and resolve the same way (see resolveWallTime).
 */
export function TimeField({
  label,
  value,
  onChange,
  testId,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  testId: string;
}) {
  const [date = "", time = ""] = value.split("T");

  return (
    <fieldset className="space-y-1.5">
      <legend className="text-sm font-medium">{label} *</legend>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-[minmax(0,1fr)_8rem]">
        <div className="space-y-1">
          <Label htmlFor={`${testId}-date`} className="text-xs">
            Date
          </Label>
          <Input
            id={`${testId}-date`}
            testId={`${testId}-date`}
            type="date"
            value={date}
            onChange={(event) =>
              onChange(
                event.target.value
                  ? `${event.target.value}${time ? `T${time}` : ""}`
                  : "",
              )
            }
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${testId}-time`} className="text-xs">
            Time
          </Label>
          <Input
            id={`${testId}-time`}
            testId={`${testId}-time`}
            type="time"
            step={60}
            value={time}
            disabled={!date}
            onChange={(event) => onChange(`${date}T${event.target.value}`)}
          />
        </div>
      </div>
    </fieldset>
  );
}

/** "02:30 on 2026-03-29" */
export function describeWall(wall: string): string {
  const [date, time] = wall.split("T");
  return `${time} on ${date}`;
}

export const COMPLETE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

export function clockName(timeZone: string | undefined): string {
  return timeZone ? `${timezonePlace(timeZone)} time` : "your device's time";
}
